const vClickOutside = {
	listener: null,

	directive: {
		beforeMount(el, binding) {
			// set up listener and keep it in element
			el._vClickOutsideListener = (e) => {
				if (!(el == e.target || el.contains(e.target))) {
					binding.value(e);
				}
			};

			// bind
			document.body.addEventListener('click', el._vClickOutsideListener);
		},

		unmounted(el) {
			// unbind & clear listener
			document.body.removeEventListener('click', el._vClickOutsideListener);
			el._vClickOutsideListener = null;
		},
	},

	plugin: {
		install(app) {
			app.directive('click-outside', vClickOutside.directive);
		},
	},
};

export default vClickOutside;
